define(
	'actions/buncees',[
	"jquery",
	"underscore",
	"backbone",
	"react",
	"dispatcher/AppDispatcher",
	"constants/actiontypes"
	],
	function($,_,Backbone,React,AppDispatcher,Constants){
		return Backbone.Model.extend({
			init: function(params) {
			},
			addBuncee: function(params) {
				AppDispatcher.dispatch({
					actionType: Constants.CREATED_BUNCEE,
					data: params
				});
			},
			create: function(data, success, failure) {
				var self = this;

				var promise = window.api.request("buncees").create({data: JSON.stringify(data)});

				promise.done(function(response) {
					self.addBuncee([response.data]);
					window.open(response.links.edit);

					if(typeof success != "undefined")
						success();
				});

				promise.fail(function(response) {
					if(typeof failure == "function") {
						failure("Failed to create buncee. Please try again.");
					}
				});
			},
			pullBunceesByLink: function(link, onComplete) {
				var self = this;
				var buncees = [];

				window.api.custom(link).each(function iterator (index, item) {
					buncees.push({
						id: item.data.guid,
						title: item.data.title,
						mongo_id: item.data.mongo_id,
						owner_guid: item.data.owner_guid,
						created_at: item.data.created_at,
						updated_at: item.data.updated_at,
						thumbnails: item.data.thumbnails,
						locked: item.data.locked,
						self: item.links.self,
						links: item.links
					});
				}, function () {
					self.addBuncee(buncees);
					if (typeof onComplete === "function") {
						onComplete();
					}
				});
			},
			pull: function(bunceeGuid, accessOption, onComplete) {
				var self = this;
				var buncees = [];
				
				accessOption = _.extend({ exclude_document: 1 }, accessOption);

				if(!bunceeGuid) {
					window.api.request("buncees", accessOption).each(function iterator (index, item) {
						buncees.push({
							id: item.data.guid,
							title: item.data.title,
							mongo_id: item.data.mongo_id,
							owner_guid: item.data.owner_guid,
							created_at: item.data.created_at,
							updated_at: item.data.updated_at,
							thumbnails: item.data.thumbnails,
							locked: item.data.locked,
							self: item.links.self,
							links: item.links
						});
					}, function () {
						self.addBuncee(buncees);
						if (typeof onComplete === "function") {
							onComplete();
						}
					});
				} else {
					window.api.request("buncees", bunceeGuid, accessOption).execute().done(function(response) {
						self.addBuncee({
							id: response.data.guid,
							title: response.data.title,
							mongo_id: response.data.mongo_id,
							owner_guid: response.data.owner_guid,
							created_at: response.data.created_at,
							updated_at: response.data.updated_at,
							thumbnails: response.data.thumbnails,
							locked: response.data.locked,
							self: response.links.self,
							links: response.links
						});
					});
				}
			},
			pullBunceesSectionGuid: function(guid){
				var self = this;
				var buncees = [];

				window.api.request("buncees", {section_guid : guid, exclude_document: 1}).each(function iterator (index, item) {
					buncees.push({
						id: item.data.guid,
						title: item.data.title,
						mongo_id: item.data.mongo_id,
						owner_guid: item.data.owner_guid,
						created_at: item.data.created_at,
						updated_at: item.data.updated_at,
						thumbnails: item.data.thumbnails,
						locked: item.data.locked,
						self: item.links.self,
						links: item.links
					});		
				}, function () {
					self.addBuncee(buncees);
					if (typeof onComplete === "function") {
						onComplete();
					}
				});
			},
			shareBunceeThruEmail: function(guid, message, recepients, success) {
				window.api.request("buncees/"+guid+"/share").create({method: "email", data:JSON.stringify({recepients: recepients, personal_message: message})}).done(function(response) {
					if(typeof window.toast == "function") {
						var toastMessage = "Sent " + recepients.length + " e-mail";
						toastMessage += recepients.length == 1 ? "." : "s.";
						window.toast(toastMessage);
					}
					success();
				}).error(function() {
					if (typeof window.toast == "function") {
						window.toast("Request failed. Please try again.");
					}
				});
			},
			convertToV3: function(guids, success, error) {
				return  window.api.request("buncees/convert").create({
					guids: guids
				});
			},
		});
	}
);
